<template>
  <section class="sessions-rail">
    <ul
      ref="parentEl"
      :style="{ height: height, overflow: overflow }"
      class="sessions-rail__list show-more__item"
    >
      <li
        v-for="([key, session, config], ix) in sessions"
        :key="key"
        :ref="ref(ix, sessions.length)"
        :class="sessionClasses(ix)"
      >
        <session-summary
          v-bind="config"
          :title-key="key"
          :title-level="4"
          :sessions="session"
          :length="session.length"
          :show-more-start-ix="session.length > 1 ? 0 : 1"
          show-more-text="See ${x} sold out sessions"
          show-less-text="Hide ${x} sold out sessions"
        />
      </li>
    </ul>
    <cdr-button
      v-if="sessions.length > showMoreStartIx"
      modifier="link"
      class="sessions-rail__show-more"
      @click="toggleShowMore()"
    >
      {{ showMore }}
    </cdr-button>
  </section>
</template>
<script>
import { CdrButton } from '@rei/cedar';
import SessionSummary from './SessionSummaryComponent.vue';
import showMore from '../mixins/showMore';

export default {
  name: 'SessionsRail',
  components: {
    CdrButton,
    SessionSummary,
  },
  mixins: [showMore],
  props: {
    sessions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    sessionClasses(ix) {
      const { showMoreClasses } = this;

      return ['sessions-rail__item', showMoreClasses(ix)];
    },
  },
};
</script>
